import { Component, computed, input } from "@angular/core";
import { FieldTree } from "@angular/forms/signals";
import { FloorFilterModel } from "./search-filter-floor.model";
import { ExpandableMinMaxFilterComponent, MinMaxFilterConfig } from "src/app/shared-components/expandable-min-max-filter/expandable-min-max-filter.component";

@Component({
    selector: "search-filter-floor",
    imports: [ExpandableMinMaxFilterComponent],
    templateUrl: "./search-filter-floor.component.html",
    styleUrl: "./search-filter-floor.component.scss",
})
export class SearchFilterFloorComponent {
    filterForm = input.required<FieldTree<FloorFilterModel>>();

    protected filterConfig = computed<MinMaxFilterConfig<FloorFilterModel>>(() => ({
        filterForm: this.filterForm,
        title: "Etasje",
        fromFieldAccessor: (form) => form.floorNumberFrom,
        toFieldAccessor: (form) => form.floorNumberTo,
        expandedAccessor: (form) => form.expanded,
        fromFieldId: "floorNumberFrom",
        toFieldId: "floorNumberTo",
        cssClass: "price",
    }));
}
